import { Images } from 'assets/images';
import {
  FieldImage,
  FieldImages,
  FieldName,
  FieldValue,
  PackageLine,
  PackageMainInfo,
  PackageNameAndAddress,
  ViewDataWrapper,
  PackageCloseIcon,
} from 'admin/components/Packages/styled';

export const PackageViewModal = ({ viewModalData, handleViewModal }) => (
  <ViewDataWrapper>
    <PackageCloseIcon src={Images.closeBlueIcon} onClick={handleViewModal} />
    <PackageNameAndAddress>Package - {viewModalData.country}</PackageNameAndAddress>
    <PackageMainInfo>
      <PackageLine>
        <FieldName>Field Name</FieldName>
        <FieldValue>Field Value</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Description</FieldName>
        <FieldValue>{viewModalData.description}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Title</FieldName>
        <FieldValue>{viewModalData.title}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Country</FieldName>
        <FieldValue>{viewModalData.country}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>City</FieldName>
        <FieldValue>{viewModalData.city}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Stay Days</FieldName>
        <FieldValue>{viewModalData.stay_days}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Stay Nights</FieldName>
        <FieldValue>{viewModalData.stay_nights}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Language</FieldName>
        <FieldValue>{viewModalData.language}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Population</FieldName>
        <FieldValue>{viewModalData.population}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Ticket URL</FieldName>
        <FieldValue>{viewModalData.ticket_url}</FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Booking URL</FieldName>
        <FieldValue>{viewModalData.booking_url} </FieldValue>
      </PackageLine>

      <PackageLine>
        <FieldName>Images</FieldName>
        <FieldImages>
          <FieldImage src={Images.bali} />
          <FieldImage src={Images.bali} />
        </FieldImages>
      </PackageLine>
    </PackageMainInfo>
  </ViewDataWrapper>
);
